import * as React from "react";

import { Text } from "../..";
import { CustomYesNoJobQualification } from "../../../domain";

export const CustomYesNoQualificationView = (props: {
    qual: CustomYesNoJobQualification;
}) => {
    const { yesNoTag, customText } = props.qual;

    return (
        <>
            <li>
                <Text variant="body1">{`${customText} (${yesNoTag.description})`}</Text>
            </li>
        </>
    );
};
